(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuppy-loox-review"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cuppy-loox-slider')) {
  customElements.define('cuppy-loox-slider', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      this._init = setTimeout(() => this.init(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this._init); clearTimeout(this._timer);
      this._controller?.abort(); this._controller = null;
      this._observer?.disconnect();
    }
    init() {
      let pool;
      try { pool = JSON.parse(this.querySelector('[data-review-pool]').textContent); } catch (_) { return; }
      if (String(pool.product_id) !== this.dataset.productId) return;
      this._reviews = pool.reviews.filter(r => r.rating === 5 && r.text?.trim() && /^https:\/\/images\.loox\.io\//.test(r.image || ''));
      if (!this._reviews.length) return;
      // Shuffle the real photo reviews once per page load.
      for (let i = this._reviews.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this._reviews[i], this._reviews[j]] = [this._reviews[j], this._reviews[i]];
      }
      this._index = 0; this._focus = false; this._inView = true;
      this._autoplay = this.dataset.autoplay !== 'false';
      this._interval = Math.min(15000, Math.max(2000, Number(this.dataset.interval) || 5000));
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this._controller.signal };
      this._viewport = this.querySelector('.cuppy-review-slider__viewport');
      this.addEventListener('focusin', () => { this._focus = true; this._viewport.setAttribute('aria-live', 'polite'); this.schedule(); }, options);
      this.addEventListener('focusout', e => { this._focus = this.contains(e.relatedTarget); this._viewport.setAttribute('aria-live', this._focus ? 'polite' : 'off'); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this._motion.addEventListener('change', () => this.schedule(), options);
      this._observer = new IntersectionObserver(entries => { this._inView = entries[0].isIntersecting; this.schedule(); });
      this._observer.observe(this);
      this.querySelector('.cuppy-review-slider__card').hidden = false;
      this.render(); this.schedule();
    }
    next() { this._index = (this._index + 1) % this._reviews.length; this.render(); this.schedule(); }
    schedule() {
      clearTimeout(this._timer);
      if (this._reviews?.length > 1 && this._autoplay && !this._focus && this._inView && !document.hidden && !this._motion.matches) {
        this._timer = setTimeout(() => this.next(), this._interval);
      }
    }
    render() {
      const r = this._reviews[this._index];
      const slide = document.createElement('div'); slide.className = 'cuppy-review-slider__slide';
      slide.setAttribute('role', 'group'); slide.setAttribute('aria-roledescription', 'שקופית');
      slide.setAttribute('aria-label', `${this._index + 1} מתוך ${this._reviews.length}`);
      const image = document.createElement('img'); image.className = 'cuppy-review-slider__image';
      image.src = r.image; image.alt = 'תמונת הביקורת של ' + r.author; image.width = 64; image.height = 72; image.decoding = 'async';
      const body = document.createElement('div'); body.className = 'cuppy-review-slider__body';
      const heading = document.createElement('div'); heading.className = 'cuppy-review-slider__heading';
      const author = document.createElement('span'); author.className = 'cuppy-review-slider__author'; author.textContent = r.author;
      const stars = document.createElement('span'); stars.className = 'cuppy-review-slider__stars'; stars.textContent = '★★★★★'; stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', '5 מתוך 5 כוכבים');
      const quote = document.createElement('blockquote'); quote.className = 'cuppy-review-slider__text'; quote.dir = 'auto'; quote.textContent = r.text; quote.title = r.text;
      heading.append(author, stars); body.append(heading, quote); slide.append(image, body);
      this._viewport.replaceChildren(slide);
      this.dataset.reviewId = r.id;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
